import { render, staticRenderFns } from "./CustomEvent.vue?vue&type=template&id=b303bd52"
import script from "./CustomEvent.vue?vue&type=script&lang=js"
export * from "./CustomEvent.vue?vue&type=script&lang=js"
import style0 from "./CustomEvent.vue?vue&type=style&index=0&id=b303bd52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports